import { render, staticRenderFns } from "./backorder.vue?vue&type=template&id=74e08767&scoped=true&"
import script from "./backorder.vue?vue&type=script&lang=js&"
export * from "./backorder.vue?vue&type=script&lang=js&"
import style0 from "./backorder.vue?vue&type=style&index=0&id=74e08767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e08767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e08767')) {
      api.createRecord('74e08767', component.options)
    } else {
      api.reload('74e08767', component.options)
    }
    module.hot.accept("./backorder.vue?vue&type=template&id=74e08767&scoped=true&", function () {
      api.rerender('74e08767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/backorder.vue"
export default component.exports